import axiosClient from './axiosClient';

const alertService = {
  list(unreadOnly = false) {
    return axiosClient.get('/alerts', { params: { unreadOnly } });
  },

  markRead(id) {
    return axiosClient.put(`/alerts/${id}/read`);
  },

  markAllRead() {
    return axiosClient.put('/alerts/read-all');
  }
};

export default alertService;
